/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementItem } from '../../models/agreement-item';
import { BaseResponse } from '../../models/base-response';

export interface AgreementsControllerDelete$Params {
  id: number;
}

export function agreementsControllerDelete(http: HttpClient, rootUrl: string, params: AgreementsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AgreementItem;
      }>;
    })
  );
}

agreementsControllerDelete.PATH = '/agreements/{id}';
